import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import Timeframe from './Timeframe';
import Region from './Region';
import Slug from './Slug';
import View from './View';
import Name from './Name';
import CreateTag from './CreateTag';
import CreatePage from './CreatePage';
import AddTag from './AddTag';
import AddPage from './AddPage';
import CampaignRedirect from './Redirect';

export default function(props) {
  const {path, url} = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/name`} component={Name}/>
      <Route path={`${path}/slug`} component={Slug}/>
      <Route path={`${path}/timeframe`} component={Timeframe}/>
      <Route path={`${path}/region`} component={Region}/>
      <Route path={`${path}/view`} component={View}/>
      <Route path={`${path}/create-tag`} component={CreateTag}/>
      <Route path={`${path}/create-page`} component={CreatePage}/>
      <Route path={`${path}/add-tag`} component={AddTag}/>
      <Route path={`${path}/add-page`} component={AddPage}/>
      <Route path={`${path}/redirect`} component={CampaignRedirect}/>
      <Redirect to={`${url}/view`}/>
    </Switch>
  );
}